import { useState } from 'react';
import { rasService } from '../services/rasService';
import { ResultsRecord, QueryParams } from '../types/api';

export const useResultsBrowsing = () => {
  const [results, setResults] = useState<ResultsRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [count, setCount] = useState<number>(0);

  const searchResults = async (queryParams: QueryParams) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await rasService.browseResults(queryParams);
      
      if (response.data) {
        setResults(response.data);
        setCount(response.count || response.data.length);
      } else {
        setResults([]);
        setCount(0);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
      setResults([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  const clearResults = () => {
    setResults([]);
    setCount(0);
    setError(null);
  };

  return {
    results,
    loading,
    error,
    count,
    searchResults,
    clearResults,
  };
};